import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { ListGroupItem, Row, Col, Input } from 'reactstrap';


export default class List extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : '',
      usingThumbNails : true,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount(){
  }


  handleInputChange(e){
    if(e.target.checked){
      this.props.onAdded(this.props.index, this.props.item);
    }else{
      this.props.onRemove(this.props.index, this.props.item);
    }
  }

  render () {

    return (
      <React.Fragment>
        <ListGroupItem>
          <Row>
            <Col md={{size:8}} className="text-start">
              
              <div className="">{this.props.item.name}</div>
              <img src={this.props.item.thumbnail} width={50} height={50} alt="" />

            </Col>
            <Col md={{size:4}} className="text-end">
              <Input type="checkbox" defaultChecked={this.props.status} onChange={this.handleInputChange}/>
            </Col>
          </Row>
        </ListGroupItem>
      </React.Fragment>
    );
  }
}
